<template src="./index.html"></template>
<script>
import data from './data.js'
import config from '../../../../../../configHttp.js'
import { uploadhistorypage } from '@/api/home';
    export default {
        props:{
            showFlag:{
                type: Boolean,
                default: false
            },
            parentDeptId: {
                type: String,
                default: ""
            }
        },
        data: function() {
            return {
                accept:"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
                downloadUrl: config.baseURL + 'company/downloadTemplate',
                headData: data.headData,
                tableData:[],
                size:"mini",
                pagination: data.pagination,
                tablekey: 0
            }
        },
        created() {

        },
        mounted() {
            this.findPage();
        },
        methods: {
            // fordownloadmb(){
            //     //简单下载，交给浏览器去做处理
            //     let params = {
            //         downUrl: config.baseUrl + '/company/downloadTemplate',
            //         typeObj: {
            //             toForm: true,
            //             fileType: "xlsx",
            //             failUrl:this.$winURl
            //         },
            //         params:{},
            //     };
            //     this.$downloadcommon(params);
            // },
            //关闭
            closediag(){
                this.$emit("closediag", '')
            },
            //上传文件
            uploadclick(){
                let url=config.baseURL + 'company/importFile' //上传地址
                let params = {
                    parentDeptId: this.parentDeptId
                }
                this.$refs.uploadMinNi.upload(url, params)
            },
            //上传回调
            getUploaddata(data) {
                if (data.code == 0) {
                    this.$message.success("上传成功")
                } else {
                    //this.$message.error(data.msg)
                }
                this.findPage();
            },

            refreshTable(){
              this.findPage();
            },

            //显示条数
            sizechange(e) {
                this.pagination.pageSize = e;
                this.findPage();
            },
            //显示页码
            currentChange(e) {
                this.pagination.pageNum = e;
                this.findPage();
            },
            forSearchScreeningBox(obj){
                console.log(obj)
            },

            findPage() {
                let params = {type:"IMPORT_COMPANY"};
                params.current = this.pagination.pageNum;
                params.size = this.pagination.pageSize;
                params.sort = "create_time";
                params.order = "desc";
                uploadhistorypage(params).then((res) => {
                    this.pagination.total = res.data.data.total;
                    this.tableData = res.data.data.records;
                });
            },
        },
    }
</script>
